import { DEVICE_PATH } from 'simcards/navigation';

module.exports = {
  path: DEVICE_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardDevice'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/show/routes/device/index.js